import { render, staticRenderFns } from "./DelMenu.vue?vue&type=template&id=5c0b4943&scoped=true"
import script from "./DelMenu.vue?vue&type=script&lang=js"
export * from "./DelMenu.vue?vue&type=script&lang=js"
import style0 from "./DelMenu.vue?vue&type=style&index=0&id=5c0b4943&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0b4943",
  null
  
)

export default component.exports